"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftOtrDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const common_1 = require("./common");
/**
 * NFT OTR Dataset
 */
class NftOtrDataset extends common_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Purchase NFT via OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link NftPurchaseTangleRequest}
         * @param amount Custom amount used for the cretion of the deep link
         * @returns
         */
        this.purchase = (params, amount = 0) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.NFT_PURCHASE }), amount);
        /**
         * Bid on NFT Auction
         *
         * @param params Use {@link OtrRequest} with data based on {@link AddressValidationTangleRequest}
         * @param amount Custom amount used for the cretion of the deep link
         * @returns
         */
        this.bid = (params, amount = 0) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.NFT_BID }), amount);
        /**
         * Set NFT for sale via OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link NftSetForSaleTangleRequest}
         * @returns
         */
        this.setForSale = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.NFT_SET_FOR_SALE }, params));
        /**
         * Mint Metadata NFT via OTR (i.e Digital Twin)
         *
         * @param params Use {@link OtrRequest} with data based on {@link MintMetadataNftTangleRequest}
         * @returns
         */
        this.mintMetadataNft = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.MINT_METADATA_NFT }, params));
        /**
         * Bulk Purchase NFT via OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link NftPurchaseBulkTangleRequest}
         * @returns
         */
        this.bulkPurchase = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.NFT_PURCHASE_BULK }, params));
        /**
         * Transfer NFT deposited on platform via OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link NftTransferTangleRequest}
         * @returns
         */
        this.transfer = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.NFT_TRANSFER }, params));
    }
}
exports.NftOtrDataset = NftOtrDataset;
